export * from './components/comparativeTableOfLastSessionDataAgainstHistoricalAndLatestMonthlyData';
export * from './components/reportHeader';
export * from './components/tableScoreLastSession';

export * from './components/charts/graphDailyEvolutionOfTheScore';
export * from './components/charts/graphDistributionOfTheStepsPerformedOnTheLastDay';
export * from './components/charts/graphMonthlyEvolutionOfTheScore';
export * from './components/charts/graphStepsPerDayAndMode';
export * from './components/charts/graphTotalAmountOfTimeSinceStart';
export * from './components/charts/graphTotalNumberOfStepsFromStart';
export * from './components/charts/graphTotalSteps';
